import { GoogleSigninButtonModule } from '@abacritt/angularx-social-login';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NgxCaptchaModule } from 'ngx-captcha';
import { AccountModule } from 'src/app/account/account.module';
import { CovercySharedComponentsModule } from 'src/app/shared/CovercySharedComponents.module';
import { LoaderComponent } from 'src/app/shared/loader/loader.component';
import { MaterialModule } from 'src/app/shared/material.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { LoginLpComponent } from './login/login-lp.component';
import { RegisterLpComponent } from './register/register-lp.component';

@NgModule({
  declarations: [LoginLpComponent, RegisterLpComponent],
  imports: [
    CommonModule,
    // SocialLoginModule,
    NgxCaptchaModule,
    CovercySharedComponentsModule,
    MaterialModule,
    SharedModule,
    AccountModule,
    LoaderComponent,
    GoogleSigninButtonModule
  ],
  exports: [
    LoginLpComponent,
    RegisterLpComponent,
  ],
  providers: [],
})
export class AccountLpModule { }
